import DimensionResolver from '@/composables/charts/influx-charts/dimension-resolvers/DimensionResolver.js'
import { useRegionStore } from '@/store/regions.js'
import i18n from '@/plugins/i18n.js'
import { useInstanceStore } from '@/store/backendInstances.js'
const { t, te } = i18n.global
/**
 * Resolver for Regions
 * Matches on Any Tag Keys that are listed as a region type.
 * Returns a translation if available under 'measurements.region_specifiations.[TAGVALUE]', or the provided tag value.
 */
class RegionDimensionResolver extends DimensionResolver {
  async prepareResolver() {
    if (this.prepared) return
    await super.prepareResolver()
    this.regionStore = useRegionStore()
    await this.regionStore.ensureRegionsAreLoaded()
  }

  async doesTagKeyMatch(tag) {
    if (!this.prepared) await this.prepareResolver()
    const regionTypes = this.regionStore.getRegionTypes()
    if (!regionTypes || !Object.keys(regionTypes).length) return false
    return Object.keys(regionTypes).includes(tag)
  }

  async humanizeTagValue(tagValue) {
    if (te('measurements.region_specifications.' + tagValue)) return t('measurements.region_specifications.' + tagValue)
    return tagValue
  }
  static isRelevantForCurrentInstance() {
    return useInstanceStore().selectedInstance.instanceType === 'barn'
  }
}

export default RegionDimensionResolver
